import { render, staticRenderFns } from "./InsertInfo.vue?vue&type=template&id=45b2b7b2&scoped=true"
import script from "./InsertInfo.vue?vue&type=script&lang=js"
export * from "./InsertInfo.vue?vue&type=script&lang=js"
import style0 from "./InsertInfo.vue?vue&type=style&index=0&id=45b2b7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2b7b2",
  null
  
)

export default component.exports